// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.submit-button {
    display: inline-block;
    font-weight: 400;
   
    text-align: center;
    vertical-align: middle;
    -webkit-user-select: none;
            user-select: none;
  
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    line-height: 1.5;
  
    border: none;
    background-color: #ff6f61;
    color: white;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s ease;
    outline: none;
    padding: 5px;
    
  }
  
  .submit-button:hover {
    outline: none;
    background-color: #e65c54;
  }


  

  
.btn-success-app {
  display: inline-block;
  font-weight: 400;

  text-align: center;
  vertical-align: middle;
  -webkit-user-select: none;
          user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0;
  color: #fff;
  background-color: #1ab394;
  border-color: #1ab394;
}

.btn-success-app:hover {
  color: #fff;
  background-color: #159278;
  border-color: #14866f;
}

.btn-success-app:focus,
.btn-success-app.focus {
  box-shadow: 0 0 0 0.2rem rgba(60, 190, 164, 0.5);
}

.btn-success-app.disabled,
.btn-success-app:disabled {
  color: #fff;
  background-color: #1ab394;
  border-color: #1ab394;
}

.btn-success-app:not(:disabled):not(.disabled):active,
.btn-success-app:not(:disabled):not(.disabled).active,
.show > .btn-success-app.dropdown-toggle {
  color: #fff;
  background-color: #14866f;
  border-color: #127b66;
}

.btn-success-app:not(:disabled):not(.disabled):active:focus,
.btn-success-app:not(:disabled):not(.disabled).active:focus,
.show > .btn-success-app.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(60, 190, 164, 0.5);
}

.btn-default-app {
  display: inline-block;
  font-weight: 400;

  text-align: center;
  vertical-align: middle;
  -webkit-user-select: none;
          user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0;
  color: #f8fbfb;
  background-color: #929090;
  border-color: #c3c0c0;
  
}

.btn-default-app:hover {
  color: #edeff1;
  background-color: #a7a2a2;
  border-color: #dfdfdf;
}

.btn-default-app:focus,
.btn-default-app.focus {
  box-shadow: 0 0 0 0.2rem rgba(216, 216, 217, 0.5);
}

.btn-default-app.disabled,
.btn-default-app:disabled {
  color: #212529;
  background-color: #f8f8f8;
  border-color: #f8f8f8;
}

.btn-default-app:not(:disabled):not(.disabled):active,
.btn-default-app:not(:disabled):not(.disabled).active,
.show > .btn-default-app.dropdown-toggle {
  color: #212529;
  background-color: #dfdfdf;
  border-color: #d8d8d8;
}

.btn-default-app:not(:disabled):not(.disabled):active:focus,
.btn-default-app:not(:disabled):not(.disabled).active:focus,
.show > .btn-default-app.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(216, 216, 217, 0.5);
}


.submit-button-disables {
  border: none;
  background-color: #fff;
  color: #ff6f61;
  border-radius: 5px;
  border: 1px solid #ff6f61;
  cursor: pointer;
  transition: background-color 0.3s ease;
  outline: none;
  height: 30px !important;
  padding: 5px;
}

`, "",{"version":3,"sources":["webpack://./src/pages/certifications/certifications.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,gBAAgB;;IAEhB,kBAAkB;IAClB,sBAAsB;IACtB,yBAAyB;YACjB,iBAAiB;;IAEzB,yBAAyB;IACzB,eAAe;IACf,gBAAgB;;IAEhB,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sCAAsC;IACtC,aAAa;IACb,YAAY;;EAEd;;EAEA;IACE,aAAa;IACb,yBAAyB;EAC3B;;;;;;AAMF;EACE,qBAAqB;EACrB,gBAAgB;;EAEhB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;UACjB,iBAAiB;EACzB,6BAA6B;EAC7B,6BAA6B;EAC7B,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,gDAAgD;AAClD;;AAEA;;EAEE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,gDAAgD;AAClD;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;;EAEhB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;UACjB,iBAAiB;EACzB,6BAA6B;EAC7B,6BAA6B;EAC7B,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;;AAEvB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,iDAAiD;AACnD;;AAEA;;EAEE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,iDAAiD;AACnD;;;AAGA;EACE,YAAY;EACZ,sBAAsB;EACtB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,sCAAsC;EACtC,aAAa;EACb,uBAAuB;EACvB,YAAY;AACd","sourcesContent":[".submit-button {\n    display: inline-block;\n    font-weight: 400;\n   \n    text-align: center;\n    vertical-align: middle;\n    -webkit-user-select: none;\n            user-select: none;\n  \n    padding: 0.375rem 0.75rem;\n    font-size: 1rem;\n    line-height: 1.5;\n  \n    border: none;\n    background-color: #ff6f61;\n    color: white;\n    border-radius: 5px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n    outline: none;\n    padding: 5px;\n    \n  }\n  \n  .submit-button:hover {\n    outline: none;\n    background-color: #e65c54;\n  }\n\n\n  \n\n  \n.btn-success-app {\n  display: inline-block;\n  font-weight: 400;\n\n  text-align: center;\n  vertical-align: middle;\n  -webkit-user-select: none;\n          user-select: none;\n  background-color: transparent;\n  border: 1px solid transparent;\n  padding: 0.375rem 0.75rem;\n  font-size: 1rem;\n  line-height: 1.5;\n  border-radius: 0;\n  color: #fff;\n  background-color: #1ab394;\n  border-color: #1ab394;\n}\n\n.btn-success-app:hover {\n  color: #fff;\n  background-color: #159278;\n  border-color: #14866f;\n}\n\n.btn-success-app:focus,\n.btn-success-app.focus {\n  box-shadow: 0 0 0 0.2rem rgba(60, 190, 164, 0.5);\n}\n\n.btn-success-app.disabled,\n.btn-success-app:disabled {\n  color: #fff;\n  background-color: #1ab394;\n  border-color: #1ab394;\n}\n\n.btn-success-app:not(:disabled):not(.disabled):active,\n.btn-success-app:not(:disabled):not(.disabled).active,\n.show > .btn-success-app.dropdown-toggle {\n  color: #fff;\n  background-color: #14866f;\n  border-color: #127b66;\n}\n\n.btn-success-app:not(:disabled):not(.disabled):active:focus,\n.btn-success-app:not(:disabled):not(.disabled).active:focus,\n.show > .btn-success-app.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(60, 190, 164, 0.5);\n}\n\n.btn-default-app {\n  display: inline-block;\n  font-weight: 400;\n\n  text-align: center;\n  vertical-align: middle;\n  -webkit-user-select: none;\n          user-select: none;\n  background-color: transparent;\n  border: 1px solid transparent;\n  padding: 0.375rem 0.75rem;\n  font-size: 1rem;\n  line-height: 1.5;\n  border-radius: 0;\n  color: #f8fbfb;\n  background-color: #929090;\n  border-color: #c3c0c0;\n  \n}\n\n.btn-default-app:hover {\n  color: #edeff1;\n  background-color: #a7a2a2;\n  border-color: #dfdfdf;\n}\n\n.btn-default-app:focus,\n.btn-default-app.focus {\n  box-shadow: 0 0 0 0.2rem rgba(216, 216, 217, 0.5);\n}\n\n.btn-default-app.disabled,\n.btn-default-app:disabled {\n  color: #212529;\n  background-color: #f8f8f8;\n  border-color: #f8f8f8;\n}\n\n.btn-default-app:not(:disabled):not(.disabled):active,\n.btn-default-app:not(:disabled):not(.disabled).active,\n.show > .btn-default-app.dropdown-toggle {\n  color: #212529;\n  background-color: #dfdfdf;\n  border-color: #d8d8d8;\n}\n\n.btn-default-app:not(:disabled):not(.disabled):active:focus,\n.btn-default-app:not(:disabled):not(.disabled).active:focus,\n.show > .btn-default-app.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(216, 216, 217, 0.5);\n}\n\n\n.submit-button-disables {\n  border: none;\n  background-color: #fff;\n  color: #ff6f61;\n  border-radius: 5px;\n  border: 1px solid #ff6f61;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  outline: none;\n  height: 30px !important;\n  padding: 5px;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
